import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Brands in the web app: the Brands page in the System section (next to Settings), a brand's form,
 * and the Brand tab on the admin client page. The shell's name, logo and colours follow the brand
 * through GET /api/public/bootstrap (auth.jsx), so nothing else here is needed for that.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const brands = () => import('./Brands.jsx');

const ClientBrandTab = (() => {
  const Lazy = lazy(() => brands().then((m) => ({ default: m.ClientBrandTab })));
  return function Deferred(props) {
    return (
      <Suspense fallback={<Loading />}>
        <Lazy {...props} />
      </Suspense>
    );
  };
})();

export default {
  name: 'brands',
  adminRoutes: [
    { path: 'brands', lazy: page(brands, 'Brands') },
    { path: 'brands/new', lazy: page(brands, 'BrandEdit') },
    { path: 'brands/:uuid', lazy: page(brands, 'BrandEdit') },
  ],
  adminNav: [{ section: 'system', to: '/admin/brands', label: 'Brands', permission: 'admin.brands.read', order: 2 }],
  adminClientTabs: [
    { key: 'brand', label: 'Brand', order: 88, permission: 'admin.clients.read', Component: ClientBrandTab },
  ],
};
